import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { IErrorProperties, IErrorValidation } from 'src/app/data/common/interfaces/IRestError';
import selectors from 'src/app/redux/selectors';
import actions from 'src/app/redux/store/actions';
import { IAppState } from 'src/app/redux/store/reducers';
import ErrorModal from 'src/components/ErrorModal/ErrorModal';
import { Redirect } from 'react-router';
import ROUTE_PATHS from 'src/routing/paths';

interface IErrorModalContainerReduxProps {
  errorMessage: string;
  errorValidations: IErrorValidation[];
  errorProperties: IErrorProperties | null;
  clearError: () => AnyAction;
  hasAccessError: boolean;
  errorCode?: string | number;
}

class ErrorModalContainer extends React.Component<IErrorModalContainerReduxProps> {

  public componentDidUpdate(prevProps: Readonly<IErrorModalContainerReduxProps>, prevState: Readonly<{}>, snapshot?: any): void {
    if (this.props.hasAccessError) {
      this.props.clearError();
    }
  }

  public render() {
    const {
      errorMessage,
      errorValidations,
      errorProperties,
      hasAccessError,
      errorCode,
    } = this.props;
    const show = !!errorMessage;

    if (hasAccessError) {
      return <Redirect to={ROUTE_PATHS.CALENDAR}/>;
    }

    return (
      <ErrorModal
        errorMessage={errorMessage}
        errorValidations={errorValidations}
        errorProperties={errorProperties}
        show={show}
        onConfirm={this.onConfirm}
        onHide={this.onHide}
        errorCode={errorCode}
      />
    );
  }

  private onConfirm = (isCancelBtn: boolean) => {
    this.props.clearError();
    if(!isCancelBtn)
    {
      window.location.reload();
    }
  }

  private onHide = () => {
    this.props.clearError();
  }
}

export default connect(
  (state: IAppState) => ({
    hasAccessError: selectors.errors.hasAccessError(state),
    errorMessage: selectors.errors.getErrorMessage(state),
    errorValidations: selectors.errors.getErrorValidations(state),
    errorProperties: selectors.errors.getErrorProperties(state),
    errorCode: selectors.errors.getErrorCode(state),
  }),
  {
    clearError: actions.errors.clearError,
  }
)(ErrorModalContainer);
